import { IState } from './state';
import { MutationTree } from 'vuex';
import DateAndPriceData from "./interfaces/dateAndPriceData";
import CalendarData from "./interfaces/calendarData";
import UpdatedAppointment from "./interfaces/updatedAppointment";
import LocalStorageWithFallback from "@lib/cookieMessage/localStorageWithFallback";
import { isValidLocale, LOCALE } from "@constants/locale";

const DEFAULT_MAX_APPOINTMENTS = 5;
const MAX_APPOINTMENTS_ADDED = 10;

export default {
    setSelectedAppointment(state, selected: string) {
        state.selectedAppointment = selected;
    },
    setCurrentFilter(state, filter: string) {
        const localStorageWithFallback: LocalStorageWithFallback = new LocalStorageWithFallback();

        localStorageWithFallback.setItem('currentFilter', filter);
    },
    setDateAndPriceData (state, data: DateAndPriceData) {
        state.dateAndPriceData = data;
    },
    extractCalendarData (state) {
        const data: CalendarData[] = [];
        state.dateAndPriceData.months.forEach(month => {
            month.appointments.forEach(appointment => {
                if (appointment.season) {
                    data.push({ dateFrom: appointment.dateFrom, dateTo: appointment.dateTo })
                } else {
                    data.push({ dateFrom: appointment.dateFrom, dateTo: appointment.dateFrom })
                }
            });
        })
        state.calendarData = data;
    },
    initSettings (state, { trip, organizer, commissionModel, onlyNonBinding, tripType, tripUrl, checkout, locale }) {
        state.settings.trip = trip;
        state.settings.organizer = organizer;
        state.settings.commissionModel = commissionModel;
        state.settings.onlyNonBinding = onlyNonBinding;
        state.settings.tripType = tripType;
        state.settings.tripUrl = tripUrl;
        state.settings.checkout = checkout;
        state.settings.locale = isValidLocale(locale) ? locale : LOCALE.DE;
    },
    setFetchingStatus (state) {
        state.isFetching = false;
    },
    checkAppointmentToggleState (state, index) {
        const showMoreAppointments = state.dateAndPriceData.months[index].appointments.length > state.toggleState.shownItems;
        state.toggleState.showMoreAppointments = showMoreAppointments;
        state.toggleState.showMore = showMoreAppointments;
    },
    setToggleState (state, index) {
        state.toggleState.showMore = state.dateAndPriceData.months[index].appointments.length > state.toggleState.shownItems;
    },
    resetShownItems (state) {
        state.toggleState.shownItems = 5;
    },
    showMoreItems (state) {
        state.toggleState.shownItems += MAX_APPOINTMENTS_ADDED;
    },
    showLessItems (state) {
        state.toggleState.shownItems = DEFAULT_MAX_APPOINTMENTS;
    },
    expandAirportBtns (state) {
        state.showAllAirports = true;
    },
    isInCheckout (state, isInCheckout: boolean) {
        state.isInCheckout = isInCheckout;
    },
    setUpdatedData(state, updatedAppointment: UpdatedAppointment) {
        state.updatedAppointment = updatedAppointment;
    },
    resetUpdateAppointmentData(state) {
        state.updatedAppointment = undefined;
    },
    enableLoading(state) {
        state.loadingMode = true;
    },
    disableLoading(state) {
        state.loadingMode = false;
    },
    enableScrollIntoView(state) {
        state.scrollMonthIntoView = true;
    },
    disableScrollIntoView(state) {
        state.scrollMonthIntoView = false;
    }
} as MutationTree<IState>
